import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import KrFormContext, { KrFormContextLandslideType, LandslideWaters, NavHeadingsKROEnum } from "../../../../contexts/krFormContext";
import { GetOptions } from "../../../../helpers/prepareForSelect";
import CheckboxMultiField from "../../../../components/checkboxMultiField/checkboxMultiField";
import { FormSectionProps } from "./shared/types/formSectionProps";
import { createConfigValidation, validation } from "../../../../helpers/validation/validation";
import { LabelChipClassType } from "../../../../components/shared/labelChip/types/labelChipProps";
import CollectiveSelectField from "../../collectiveEditionView/collectiveField/collectiveSelectField";
import { CollectivePreviewKey } from "../../../../helpers/collective/preview";
import { getAddCommentBtnDetails, getFieldRef, getItemRef } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";
import { AdditionalIcon } from "../../../../components/shared/additionalIcon/additionalIcon";
import { ReactComponent as addCircle } from '../../../../icons/add_circle.svg';

const createDicts = (waters?: LandslideWaters[], index?: number, osuwiskoGID?: string) => {
    const elements =  waters?.filter((dict) => {
        return dict.tyP_STREFY_SID === index
    }).map((value) => {
        return value.tyP_PRZEJAWU_SID as number
    })

    if(elements === undefined || (elements && elements.length === 0)) {
        waters?.push({
            tyP_PRZEJAWU_SID: 7,
            tyP_STREFY_SID: index,
            osuwiskO_GID: osuwiskoGID
        })
        return [7];
    }
    return elements;
}

const WaterManifestation = (props: FormSectionProps) => {
    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;
    const [ErrorKoluv, setErrorKoluv] = useState<boolean>(false);
    const [ErrorMsgKoluv, setErrorMsgKoluv] = useState<string>('');
    const [ErrorMainSlope, setErrorMainSlope] = useState<boolean>(false);
    const [ErrorMsgMainSlope, setErrorMsgMainSlope] = useState<string>('');
    const [ErrorSlopeBelow, setErrorSlopeBelow] = useState<boolean>(false);
    const [ErrorMsgSlopeBelow, setErrorMsgSlopeBelow] = useState<string>('');
    const [ErrorSlopeOnsides, setErrorSlopeOnsides] = useState<boolean>(false);
    const [ErrorMsgSlopeOnsides, setErrorMsgSlopeOnsides] = useState<string>('');
    const [WaterManifestationKoluviaSelected, setWaterManifestationKoluviaSelected] = useState< number[] | undefined>(createDicts(krForm?.waters, 1));
    const [WaterManifestationMainSlopeSelected, setWaterManifestationMainSlopeSelected] = useState< number[] | undefined>(createDicts(krForm?.waters, 2));
    const [WaterManifestationSlopeBelowSelected, setWaterManifestationSlopeBelowSelected] = useState< number[] | undefined>(createDicts(krForm?.waters, 3));
    const [WaterManifestationSlopeOnsidesSelected, setWaterManifestationSlopeOnsidesSelected] = useState< number[] | undefined>(createDicts(krForm?.waters, 4));

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {

            const currValidation = createConfigValidation("waterManifestation", false);
            const errorMsgKoluv = validation(currValidation, krForm.waters?.filter((water) => {return water.tyP_STREFY_SID === 1}));
            if (errorMsgKoluv !== '' && errorMsgKoluv !== undefined) {
                setErrorKoluv(true);
                setErrorMsgKoluv(errorMsgKoluv);
            }
            var errorMsgMainSlope = validation(currValidation, krForm.waters?.filter((water) => {return water.tyP_STREFY_SID === 2}));
            if (errorMsgMainSlope !== '' && errorMsgMainSlope !== undefined) {
                setErrorMainSlope(true);
                setErrorMsgMainSlope(errorMsgMainSlope);
            }
            var errorMsgSlopeBelow = validation(currValidation, krForm.waters?.filter((water) => {return water.tyP_STREFY_SID === 3}));
            if (errorMsgSlopeBelow !== '' && errorMsgSlopeBelow !== undefined) {
                setErrorSlopeBelow(true);
                setErrorMsgSlopeBelow(errorMsgSlopeBelow);
            }
            var errorMsgSlopeOnsides = validation(currValidation, krForm.waters?.filter((water) => {return water.tyP_STREFY_SID === 4}));
            if (errorMsgSlopeOnsides !== '' && errorMsgSlopeOnsides !== undefined) {
                setErrorSlopeOnsides(true);
                setErrorMsgSlopeOnsides(errorMsgSlopeOnsides);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])


    var WaterManifestationDict = useMemo(() => GetOptions("TYP_PRZEJAWU_SID", krForm.dictionaries, true), [krForm.dictionaries]);

    const createDisabledElems = useCallback((dElems: number[], waters?: LandslideWaters[], index?: number) => {
        waters?.filter((dict) => {
            return dict.tyP_STREFY_SID === index
        }).forEach((value, idx) => {
            if (index === 1 && value.czY_ANALIZA) {
                var disabledElem = WaterManifestationDict?.findIndex((option) => {
                    return option.value === value.tyP_PRZEJAWU_SID;
                })
                if (disabledElem !== undefined) {
                    dElems.push(disabledElem);
                }
            }
            if (WaterManifestationDict && !dElems.includes(WaterManifestationDict.length - 1) && dElems.length > 0) {
                dElems.push(WaterManifestationDict.length - 1);
            }
        });
        return dElems;
    }, [WaterManifestationDict])

    var disabledElements: number[] = useMemo(() => {
        let dElems: number[] = [];
        createDisabledElems(dElems, krForm.waters, 1);
        createDisabledElems(dElems, krForm.waters, 2);
        createDisabledElems(dElems, krForm.waters, 3);
        createDisabledElems(dElems, krForm.waters, 4);
        return dElems;
    }, [createDisabledElems, krForm.waters]);

    const onChangeCheckbox = (value: string | number | undefined, checked: boolean, zone?: number) => {
        var form = Object.assign({}, krForm);
        var Index: number = -1;
        var water = form.waters?.find((water, index) => {
            Index = index;
            return (water.tyP_PRZEJAWU_SID === value && water.tyP_STREFY_SID === zone)
        });
        if (water && !checked && Index > -1) {
            form.waters?.splice(Index, 1);
        }

        var option = WaterManifestationDict?.find((option) => {
            return option.value === value;
        })

        if (option?.name === "brak" && checked) {
            if (form.waters?.length) {
                form.waters = form.waters?.filter((water) => {
                    return (water.tyP_STREFY_SID !== zone)
                })
            }
        }
        else {
            if (form.waters?.length && checked) {
                var optionSecond = WaterManifestationDict?.find((option) => {
                    return option.name === "brak";
                })
                if (optionSecond) {
                    var indexAbsence: number = -1;
                    var toDelete = form.waters?.find((water, index) => {
                        indexAbsence = index;
                        return (water.tyP_STREFY_SID === zone && optionSecond?.value === water.tyP_PRZEJAWU_SID)
                    })
                    if (toDelete && indexAbsence > -1) form.waters?.splice(indexAbsence, 1);
                }
            }
        }
        if (water === undefined && checked) {
            if (form.waters === undefined) {
                form.waters = [];
            }
            var waterObject: LandslideWaters = {
                tyP_PRZEJAWU_SID: value as number,
                tyP_STREFY_SID: zone,
                osuwiskO_GID: krForm.landslideAttributes?.globalid
            }
            form.waters?.push(waterObject);
        }
        if (zone === 1) setWaterManifestationKoluviaSelected(createDicts(form?.waters, 1, krForm.landslideAttributes?.globalid));
        if (zone === 2) setWaterManifestationMainSlopeSelected(createDicts(form?.waters, 2, krForm.landslideAttributes?.globalid));
        if (zone === 3) setWaterManifestationSlopeBelowSelected(createDicts(form?.waters, 3, krForm.landslideAttributes?.globalid));
        if (zone === 4) setWaterManifestationSlopeOnsidesSelected(createDicts(form?.waters, 4, krForm.landslideAttributes?.globalid));

        refreshValidation(form.waters?.filter((water) => {return water.tyP_STREFY_SID === zone}), zone);
        setkrForm(form);
    }

    const refreshValidation = (values: LandslideWaters[] | undefined, type: number | undefined) => {
        const currValidation = createConfigValidation("waterManifestation", false);
        const currValidationMsg = validation(currValidation, values);
        if (type === 1) {
            if (currValidationMsg) {
                setErrorKoluv(true);
                setErrorMsgKoluv(currValidationMsg);
            } else {
                setErrorKoluv(false);
                setErrorMsgKoluv('');
            }
        }
        if (type === 2) {
            if (currValidationMsg) {
                setErrorMainSlope(true);
                setErrorMsgMainSlope(currValidationMsg);
            } else {
                setErrorMainSlope(false);
                setErrorMsgMainSlope('');
            }
        }
        if (type === 3) {
            if (currValidationMsg) {
                setErrorSlopeBelow(true);
                setErrorMsgSlopeBelow(currValidationMsg);
            } else {
                setErrorSlopeBelow(false);
                setErrorMsgSlopeBelow('');
            }
        }
        if (type === 4) {
            if (currValidationMsg) {
                setErrorSlopeOnsides(true);
                setErrorMsgSlopeOnsides(currValidationMsg);
            } else {
                setErrorSlopeOnsides(false);
                setErrorMsgSlopeOnsides('');
            }
        }
    }

    const getAddCommentBtn = (KRFieldDict: KROFieldDict, filedName: string) => {
        return getAddCommentBtnDetails(props.editMode!, KRFieldDict, filedName, props.setNewCommentFieldDetails!);
    }

    var addCommentBtnStyle: React.CSSProperties = {
        height: "10%", 
        top: "100%", 
        borderRadius: "4px",
        width: "100%"
    }

    if (props.collectiveEdition) {
        return (
            <>
                <h2 style={{ width: '100%' }}>7. Przejawy wód powierzchniowych i gruntowych w obrębie</h2>
                <CollectiveSelectField top={true} value={WaterManifestationMainSlopeSelected} isAuto={false} title={"Skarpy głównej i stoku powyżej skarpy"}
                    forms={props.forms} keyName={CollectivePreviewKey.waterMainSlope} actions={props.actions} single={false}
                    setActions={props.setActions} onDelete={props.onDelete} dic={WaterManifestationDict} labelClass={LabelChipClassType.Checkbox}>
                    <CheckboxMultiField indexElement={2} oneColumn={false} onChange={onChangeCheckbox} labelName="Skarpy głównej i stoku powyżej skarpy"
                        checkboxOptions={WaterManifestationDict} selectedValues={WaterManifestationMainSlopeSelected} />
                </CollectiveSelectField>
                <CollectiveSelectField top={true} value={WaterManifestationSlopeBelowSelected} isAuto={false} title={"Stoku poniżej osuwiska"}
                    forms={props.forms} keyName={CollectivePreviewKey.waterSlopeBelow} actions={props.actions} single={false}
                    setActions={props.setActions} onDelete={props.onDelete} dic={WaterManifestationDict} labelClass={LabelChipClassType.Checkbox}>
                    <CheckboxMultiField indexElement={3} oneColumn={false} onChange={onChangeCheckbox} labelName="Stoku poniżej osuwiska"
                        checkboxOptions={WaterManifestationDict} selectedValues={WaterManifestationSlopeBelowSelected} />
                </CollectiveSelectField>
                <CollectiveSelectField top={true} value={WaterManifestationSlopeOnsidesSelected} isAuto={false} title={"Stoku po bokach osuwiska"}
                    forms={props.forms} keyName={CollectivePreviewKey.waterSlopeOnsides} actions={props.actions} single={false}
                    setActions={props.setActions} onDelete={props.onDelete} dic={WaterManifestationDict} labelClass={LabelChipClassType.Checkbox}>
                    <CheckboxMultiField indexElement={4} oneColumn={false} onChange={onChangeCheckbox} labelName="Stoku po bokach osuwiska"
                        checkboxOptions={WaterManifestationDict} selectedValues={WaterManifestationSlopeOnsidesSelected} />
                </CollectiveSelectField>
            </>
        )
    }
    
    return (
        <>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.WaterManifestation, props.getMapForNavScroll!)} style={{ width: '100%' }}>7. Przejawy wód powierzchniowych i gruntowych w obrębie</h2>
            <div style={{ width: '23%', position: "relative", paddingBottom: "10px" }}
                ref={(node: any) => {getFieldRef(node, KROFieldDict.przejWod_koluwium, props.getMapForComment!)}}
                onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.przejWod_koluwium); }}
            >
                <CheckboxMultiField disableAllElements={!props.editMode} error={ErrorKoluv} errorMsg={ErrorMsgKoluv} indexElement={1} oneColumn={true} onChange={onChangeCheckbox} labelName="Koluwium"
                    checkboxOptions={WaterManifestationDict} selectedValues={WaterManifestationKoluviaSelected} disabledElementsIndex={disabledElements} />
                {!props.editMode && 
                    <div 
                        style={addCommentBtnStyle}
                        className={`addCommentBtnWrapperRegular addCommentBtnWrapper ${props.markedFieldForCommentFiltering === KROFieldDict.przejWod_koluwium ? "activeAddCommentBtn" : ""}`} 
                        onClick={getAddCommentBtn(KROFieldDict.przejWod_koluwium, "Koluwium - Przejawy wód").onClick}>
                        {AdditionalIcon(addCircle)}
                    </div>
                }
            </div>
            <div style={{ width: '23%', position: "relative", paddingBottom: "10px" }}
                ref={(node: any) => {getFieldRef(node, KROFieldDict.przejWod_skarpyGlownejIStokuPowyzejSkarpy, props.getMapForComment!)}}
                onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.przejWod_skarpyGlownejIStokuPowyzejSkarpy); }}
            >
                <CheckboxMultiField disableAllElements={!props.editMode} error={ErrorMainSlope} errorMsg={ErrorMsgMainSlope} indexElement={2} oneColumn={true} onChange={onChangeCheckbox} labelName="Skarpy głównej i stoku powyżej skarpy"
                    checkboxOptions={WaterManifestationDict} selectedValues={WaterManifestationMainSlopeSelected} />
                {!props.editMode && 
                <div 
                    style={addCommentBtnStyle}
                    className={`addCommentBtnWrapperRegular addCommentBtnWrapper ${props.markedFieldForCommentFiltering === KROFieldDict.przejWod_skarpyGlownejIStokuPowyzejSkarpy ? "activeAddCommentBtn" : ""}`} 
                    onClick={getAddCommentBtn(KROFieldDict.przejWod_skarpyGlownejIStokuPowyzejSkarpy, "Skarpy głównej i stoku powyżej skarpy - Przejawy wód").onClick}>
                    {AdditionalIcon(addCircle)}
                </div>
                }
            </div>
            <div style={{ width: '23%', position: "relative", paddingBottom: "10px" }}
                ref={(node: any) => {getFieldRef(node, KROFieldDict.przejWod_stokuPonizejOsuwiska, props.getMapForComment!)}}
                onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.przejWod_stokuPonizejOsuwiska); }}
            >
                <CheckboxMultiField disableAllElements={!props.editMode} error={ErrorSlopeBelow} errorMsg={ErrorMsgSlopeBelow} indexElement={3} oneColumn={true} onChange={onChangeCheckbox} labelName="Stoku poniżej osuwiska"
                    checkboxOptions={WaterManifestationDict} selectedValues={WaterManifestationSlopeBelowSelected} />
                {!props.editMode && 
                <div 
                    style={addCommentBtnStyle}
                    className={`addCommentBtnWrapperRegular addCommentBtnWrapper ${props.markedFieldForCommentFiltering === KROFieldDict.przejWod_stokuPonizejOsuwiska ? "activeAddCommentBtn" : ""}`} 
                    onClick={getAddCommentBtn(KROFieldDict.przejWod_stokuPonizejOsuwiska, "Stoku poniżej osuwiska - Przejawy wód").onClick}>
                    {AdditionalIcon(addCircle)}
                </div>
                }
            </div>
            <div style={{ width: '23%', position: "relative", paddingBottom: "10px" }}
                ref={(node: any) => {getFieldRef(node, KROFieldDict.przejWod_stokuPoBokachOsuwiska, props.getMapForComment!)}}
                onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.przejWod_stokuPoBokachOsuwiska); }}
            >
                <CheckboxMultiField disableAllElements={!props.editMode} error={ErrorSlopeOnsides} errorMsg={ErrorMsgSlopeOnsides} indexElement={4} oneColumn={true} onChange={onChangeCheckbox} labelName="Stoku po bokach osuwiska"
                    checkboxOptions={WaterManifestationDict} selectedValues={WaterManifestationSlopeOnsidesSelected} />
                {!props.editMode && 
                <div 
                    style={addCommentBtnStyle}
                    className={`addCommentBtnWrapperRegular addCommentBtnWrapper ${props.markedFieldForCommentFiltering === KROFieldDict.przejWod_stokuPoBokachOsuwiska ? "activeAddCommentBtn" : ""}`} 
                    onClick={getAddCommentBtn(KROFieldDict.przejWod_stokuPoBokachOsuwiska, "Stoku po bokach osuwiska - Przejawy wód").onClick}>
                    {AdditionalIcon(addCircle)}
                </div>
                }
            </div>
        </>
    )
}

export default WaterManifestation;